import * as tslib_1 from "tslib";
import * as React from 'react';
import ReadingPaneQuick from './components/ReadingPaneQuick';
import ReadingPaneFull from './components/ReadingPaneFull';
import discardReadingPaneOption from './actions/discardReadingPaneOption';
import { saveReadingPaneOptionFull } from './actions/saveReadingPaneOption';
import isReadingPaneOptionDirty from './utils/isReadingPaneOptionDirty';
var ReadingPaneOption = {
    key: 'readingPane',
    titleStringKey: 'optionTitle_readingPane',
    searchTermsStringKey: 'optionTitle_readingPane',
    fullOptionFormSettings: {
        render: function () { return React.createElement(ReadingPaneFull, null); },
        isDirty: isReadingPaneOptionDirty,
        onSave: saveReadingPaneOptionFull,
        onDiscard: discardReadingPaneOption,
    },
    quickOptionSettings: {
        rendering: {
            render: function (props) { return (React.createElement(ReadingPaneQuick, tslib_1.__assign({}, props))); },
        },
        order: 3 /* ReadingPane */,
        workloads: 1 /* Mail */,
        customTitle: 'options_readingPane_quickSetting_label',
    },
};
export default ReadingPaneOption;
//# sourceMappingURL=ReadingPaneOption.js.map